function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var GenericException = /*#__PURE__*/_createClass(
/*
* GenericException is a class for abstracting all errors in this project.
* Error handling is not delt within this project, it exposes all exeptions with this error interface
*/
function GenericException(_ref) {
  var message = _ref.message,
    _ref$fileName = _ref.fileName,
    fileName = _ref$fileName === void 0 ? '' : _ref$fileName,
    _ref$lineNumber = _ref.lineNumber,
    lineNumber = _ref$lineNumber === void 0 ? '' : _ref$lineNumber,
    _ref$extra = _ref.extra,
    extra = _ref$extra === void 0 ? {} : _ref$extra;
  _classCallCheck(this, GenericException);
  this.stack = Error().stack;
  this.name = this.constructor.name;
  this.message = message;
  this.fileName = fileName;
  this.lineNumber = lineNumber;
  this.extra = extra;
});
var ValidationException = /*#__PURE__*/function (_GenericException) {
  /*
  * Class for dealing with all Validation errors
  */
  function ValidationException(_ref2) {
    var message = _ref2.message,
      _ref2$fileName = _ref2.fileName,
      fileName = _ref2$fileName === void 0 ? '' : _ref2$fileName,
      _ref2$lineNumber = _ref2.lineNumber,
      lineNumber = _ref2$lineNumber === void 0 ? '' : _ref2$lineNumber,
      _ref2$extra = _ref2.extra,
      extra = _ref2$extra === void 0 ? {} : _ref2$extra;
    _classCallCheck(this, ValidationException);
    return _callSuper(this, ValidationException, [{
      message: message,
      fileName: fileName,
      lineNumber: lineNumber,
      extra: extra
    }]);
  }
  _inherits(ValidationException, _GenericException);
  return _createClass(ValidationException);
}(GenericException);
var NotImplementationExeption = /*#__PURE__*/function (_GenericException2) {
  /*
  * Class for dealing with not implemented methods
  */
  function NotImplementationExeption(_ref3) {
    var message = _ref3.message,
      _ref3$fileName = _ref3.fileName,
      fileName = _ref3$fileName === void 0 ? '' : _ref3$fileName,
      _ref3$lineNumber = _ref3.lineNumber,
      lineNumber = _ref3$lineNumber === void 0 ? '' : _ref3$lineNumber,
      _ref3$extra = _ref3.extra,
      extra = _ref3$extra === void 0 ? {} : _ref3$extra;
    _classCallCheck(this, NotImplementationExeption);
    return _callSuper(this, NotImplementationExeption, [{
      message: message,
      fileName: fileName,
      lineNumber: lineNumber,
      extra: extra
    }]);
  }
  _inherits(NotImplementationExeption, _GenericException2);
  return _createClass(NotImplementationExeption);
}(GenericException);
var ExternalTrackingExeption = /*#__PURE__*/function (_GenericException3) {
  /*
  * Class for dealing with errors thrown by external tracking services
  */
  function ExternalTrackingExeption(_ref4) {
    var _this;
    var message = _ref4.message,
      _ref4$externalTrackin = _ref4.externalTrackingService,
      externalTrackingService = _ref4$externalTrackin === void 0 ? '' : _ref4$externalTrackin,
      _ref4$fileName = _ref4.fileName,
      fileName = _ref4$fileName === void 0 ? '' : _ref4$fileName,
      _ref4$lineNumber = _ref4.lineNumber,
      lineNumber = _ref4$lineNumber === void 0 ? '' : _ref4$lineNumber,
      _ref4$extra = _ref4.extra,
      extra = _ref4$extra === void 0 ? {} : _ref4$extra;
    _classCallCheck(this, ExternalTrackingExeption);
    _this = _callSuper(this, ExternalTrackingExeption, [{
      message: message,
      fileName: fileName,
      lineNumber: lineNumber,
      extra: extra
    }]);
    _this.externalTrackingService = externalTrackingService;
    return _this;
  }
  _inherits(ExternalTrackingExeption, _GenericException3);
  return _createClass(ExternalTrackingExeption);
}(GenericException);
export { GenericException, ValidationException, NotImplementationExeption, ExternalTrackingExeption };